// Parses a numbered remediation-steps string ("1. Do X 2. Do Y", one step per line or all on
// one line) into an array of step texts. Returns null when the text has no numbered steps so
// callers can fall back to their own rendering.
//
// A step marker is a number followed by ".", ")" or ":" and then either whitespace or the start
// of the step text ("1. Map", "1.Map", "1:Review" all count). Question-bank content is written
// by reviewers in spreadsheets and the numbering style varies row by row; AX-133 shipped a
// Ransomware row numbered "1:Review ..." that the old "number, dot, space" parser rejected, so
// the risk showed "No remediation steps available." with the steps sitting in the database.
//
// Steps must be numbered consecutively from 1. A number that is out of sequence is treated as
// part of the previous step's text (e.g. "... within 30 days. 2019 guidance ..." must not start
// a new step), which is why a marker also needs the step text to begin with a letter when there
// is no space after it - a bare "3.14" or "8.2" inside a sentence is not a step.
const STEP_SPLIT = /\d+[.):](?:\s+|(?=[A-Za-z]))[^]+?(?=\s\d+[.):](?:\s|[A-Za-z])|$)/g;
const STEP_PREFIX = /^(\d+)[.):]\s*/;

export function parseRemediationSteps(rawSteps) {
  if (typeof rawSteps !== "string" || rawSteps.trim().length === 0) return null;
  const matches = rawSteps.match(STEP_SPLIT);
  if (!matches) return null;
  const cleanedSteps = [];
  let expectedNumber = 1;
  matches.forEach((step) => {
    const numberMatch = step.match(STEP_PREFIX);
    const stepNumber = numberMatch ? parseInt(numberMatch[1], 10) : null;
    if (stepNumber === expectedNumber) {
      cleanedSteps.push(step.replace(STEP_PREFIX, "").trim());
      expectedNumber++;
    } else if (cleanedSteps.length > 0) {
      cleanedSteps[cleanedSteps.length - 1] += " " + step.trim();
    }
  });
  return cleanedSteps.length > 0 ? cleanedSteps : null;
}
